import { render, staticRenderFns } from "./ProjectRoomsComponent.vue?vue&type=template&id=273b8ab8&scoped=true"
import script from "./ProjectRoomsComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectRoomsComponent.vue?vue&type=script&lang=ts"
import style0 from "./ProjectRoomsComponent.vue?vue&type=style&index=0&id=273b8ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b8ab8",
  null
  
)

export default component.exports